import { SyntheticEvent, useCallback, useEffect, useState } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { useRestWebsiteContext } from '@app/components/providers/rest/rest-website'
import { EditableMixture } from '@app/components/mixtures/editable-mixture'
import { a11yDark } from '@app/styles'
import { AccessibilityStandardKeys } from '@app/components/general/select/select-input'
import { ctaSubmitStyle, lineProps } from './styles'

const CtaHtmlInputRest = ({
  standard,
  queryModalVisible,
  runners,
}: {
  queryModalVisible?: boolean
  standard?: AccessibilityStandardKeys
  runners?: string[]
}) => {
  const { t, lang } = useTranslation('common')
  const { html, setHtml, loading, toggleModal } = useRestWebsiteContext()
  const [loaded, setLoaded] = useState<boolean>(false)

  useEffect(() => {
    if (queryModalVisible && !loaded) {
      setLoaded(true)
    }
  }, [queryModalVisible, loaded])

  const submitForm = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e?.preventDefault()
      await toggleModal({ html, standard, runners, lang }, true)
    },
    [toggleModal, html, standard, runners, lang]
  )

  return (
    <form className={`w-full block`} onSubmit={submitForm} noValidate>
      {loaded ? (
        <EditableMixture
          language='html'
          style={a11yDark}
          lineProps={lineProps}
          setScript={setHtml}
          editMode={true}
        >
          {html || ''}
        </EditableMixture>
      ) : null}
      <button
        className={ctaSubmitStyle}
        type={'submit'}
        disabled={loading || !html}
      >
        {t('analyze')} HTML
      </button>
    </form>
  )
}

export { CtaHtmlInputRest }
